module.exports = __webpack_public_path__ + "img/dogUnit.416f0b1a.png";